import { apiClient } from './client';

export interface ChecklistItem {
  id: string;
  checklistId: string;
  description: string;
  notes?: string;
  isRequired: boolean;
  isCompleted: boolean;
  completedBy?: string;
  completedAt?: string;
  sortOrder: number;
}

export interface Checklist {
  id: string;
  caseId: string;
  name: string;
  templateId?: string;
  createdBy: string;
  isActive: boolean;
  createdAt: string;
  items: ChecklistItem[];
}

export interface ChecklistsResponse {
  success: boolean;
  checklists: Checklist[];
}

export interface ChecklistResponse {
  success: boolean;
  checklist: Checklist;
  message?: string;
}

export interface ChecklistItemResponse {
  success: boolean;
  item: ChecklistItem;
  message?: string;
}

export class ChecklistsApi {
  /**
   * Get all checklists for a case
   */
  static async getChecklists(caseId: string): Promise<ChecklistsResponse> {
    return apiClient.get(`/case/${caseId}/checklists`);
  }

  /**
   * Create or update a checklist with items
   */
  static async createChecklist(
    caseId: string,
    data: {
      name: string;
      templateId?: string;
      items: Array<{
        document: string;
        notes?: string;
        isRequired?: boolean;
        sortOrder?: number;
      }>;
    }
  ): Promise<ChecklistResponse> {
    return apiClient.post(`/case/${caseId}/checklists`, data);
  }

  /**
   * Toggle a checklist item completion status
   */
  static async toggleChecklistItem(
    caseId: string,
    checklistId: string,
    itemId: string
  ): Promise<ChecklistItemResponse> {
    return apiClient.patch(
      `/case/${caseId}/checklists/${checklistId}/items/${itemId}/toggle`,
      {}
    );
  }

  /**
   * Update a checklist item
   */
  static async updateChecklistItem(
    caseId: string,
    checklistId: string,
    itemId: string,
    data: {
      isCompleted?: boolean;
      notes?: string;
    }
  ): Promise<ChecklistItemResponse> {
    return apiClient.patch(
      `/case/${caseId}/checklists/${checklistId}/items/${itemId}`,
      data
    );
  }
}
